import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLeadsDatabaseContext } from '@pages/LeadsDatabase/context';
import styled from 'styled-components';

import { Tabs } from '@components/theme-v2';

import { Tabs as TabsEnum } from '../enums';

const Container = styled.div`
  width: 100%;
`;

const StyledDivider = styled.div`
  height: 1px;
  background: var(--sk-surface-border);
  margin-top: -1px;
`;

const config = [
  { label: 'common.titles.myLeads', value: TabsEnum.MY_LEADS },
  { label: 'common.titles.scrapekingDatabase', value: TabsEnum.SCRAPEKING_DB },
];

const ToggleTabs: FC = () => {
  const { t } = useTranslation();
  const { tab, handleChange } = useLeadsDatabaseContext();

  return (
    <Container>
      <Tabs value={tab} onChange={val => handleChange({} as any, val as TabsEnum)} variant="underline">
        <Tabs.List>
          {config.map(v => (
            <Tabs.Tab key={v.value} value={v.value}>
              {t(v.label)}
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs>
      <StyledDivider />
    </Container>
  );
};

export default memo(ToggleTabs);
